import { isAxiosError } from 'axios';
import { apiClient } from '@/axios';
import { Endpoints } from '@/enums';
import { RoRoPageData, RoRoPageViajes } from '@/types/dashboard/RoRoPage';

// Modificar cuando tengamos una response de ejemplo

type GetRoRoPageResponse = {
  value: RoRoPageData;
};

type RoRoPageQueryType = {
  viaje: number;
  armador: string;
};

export const getDashboardRoRoPageData = async (
  query: RoRoPageQueryType
): Promise<RoRoPageData> => {
  try {
    const res = await apiClient.post<GetRoRoPageResponse>(
      Endpoints.DashboardRoRoPage,
      query
    );
    return res.data.value || {};
  } catch (error) {
    if (isAxiosError(error) && error.response) {
      if (error.response.status === 404) {
        throw new Error('Invalid Data');
      } else {
        throw new Error(error.message);
      }
    } else {
      throw error;
    }
  }
};

// Modificar cuando tengamos una response de ejemplo

type GetRoRoPageViajesResponse = {
  value: RoRoPageViajes[];
};

type RoRoPageViajesQueryType = {
  armador: string;
};

export const getDashboardRoRoPageViajesData = async (
  query: RoRoPageViajesQueryType
): Promise<RoRoPageViajes[]> => {
  try {
    const res = await apiClient.post<GetRoRoPageViajesResponse>(
      Endpoints.DashboardRoRoViajes,
      query
    );
    return res.data.value || [];
  } catch (error) {
    if (isAxiosError(error) && error.response) {
      if (error.response.status === 404) {
        throw new Error('Invalid Data');
      } else {
        throw new Error(error.message);
      }
    } else {
      throw error;
    }
  }
};
